var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"maskmodal-w",style:({ top: _vm.$store.state.global.headerH + 'px' }),on:{"touchmove":function($event){$event.preventDefault();}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }